var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49994 16.5084L6.40827 13.425L7.58327 12.2417L9.49994 14.1584L16.4083 7.2417L17.5833 8.42503L9.49994 16.5084Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C10.0222 22 8.08879 21.4135 6.4443 20.3147C4.7998 19.2159 3.51808 17.6541 2.7612 15.8268C2.00433 13.9996 1.8063 11.9889 2.19215 10.0491C2.57801 8.10929 3.53039 6.32746 4.92892 4.92894C6.32745 3.53041 8.10927 2.578 10.0491 2.19215C11.9889 1.8063 13.9996 2.00433 15.8268 2.76121C17.6541 3.51809 19.2159 4.79981 20.3147 6.4443C21.4135 8.08879 22 10.0222 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22ZM12 3.66667C10.3518 3.66667 8.74066 4.15541 7.37025 5.07109C5.99984 5.98677 4.93173 7.28826 4.30099 8.81098C3.67026 10.3337 3.50523 12.0092 3.82678 13.6258C4.14832 15.2423 4.94199 16.7271 6.10743 17.8926C7.27287 19.058 8.75774 19.8517 10.3742 20.1732C11.9908 20.4948 13.6663 20.3297 15.189 19.699C16.7118 19.0683 18.0132 18.0002 18.9289 16.6298C19.8446 15.2593 20.3333 13.6482 20.3333 12C20.3333 9.78987 19.4554 7.67025 17.8926 6.10745C16.3298 4.54465 14.2101 3.66667 12 3.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.b88fbdf06b5a5837f7ce0d0c38e58de3.svg";
export { ForwardRef as ReactComponent };